/*
  Dabi Deri — ürün yorumları: süzme, sıralama, "daha fazla", uzun metin,
  ışık kutusu (fotoğraf + video), form yıldızları.

  Her şey sunucudan gelen DOM üzerinde çalışır; veri istek yapılmaz.
  Bölüm birden fazla kez basılabilir (ürün + ana sayfa), her biri kendi
  kökünde çalışır. Tema düzenleyicide yeniden yüklenince yeniden kurulur.
*/
(() => {
  const setup = (root) => {
    if (!root || root.dataset.dabiReviewsReady === 'true') return;
    root.dataset.dabiReviewsReady = 'true';

    const perPage = Math.max(1, Number(root.dataset.perPage) || 6);
    const list = root.querySelector('[data-dabi-review-list]');
    const items = list ? Array.from(list.querySelectorAll('[data-dabi-review]')) : [];
    const noneMsg = root.querySelector('[data-dabi-review-none]');
    const moreBtn = root.querySelector('[data-dabi-review-more-btn]');
    const remaining = root.querySelector('[data-dabi-review-remaining]');
    const sortSel = root.querySelector('[data-dabi-review-sort]');
    const chips = Array.from(root.querySelectorAll('[data-dabi-review-filter]'));
    const resetChip = root.querySelector('.dabi-reviews__chip--reset');

    let filter = 'all';
    let sort = 'new';
    let shown = perPage;

    /* ---------- süzme + sıralama + sayfalama ---------- */
    const matches = (item) => {
      if (filter === 'all') return true;
      if (filter === 'media') return Number(item.dataset.media) > 0;
      return Number(item.dataset.rating) === Number(filter);
    };

    const order = (a, b) => {
      const ra = Number(a.dataset.rating);
      const rb = Number(b.dataset.rating);
      const ta = Number(a.dataset.ts);
      const tb = Number(b.dataset.ts);
      const ma = Number(a.dataset.media);
      const mb = Number(b.dataset.media);
      switch (sort) {
        case 'high':
          return rb - ra || tb - ta;
        case 'low':
          return ra - rb || tb - ta;
        case 'media':
          return (mb > 0) - (ma > 0) || tb - ta;
        default:
          return tb - ta;
      }
    };

    const render = () => {
      if (!list) return;
      const pool = items.filter(matches).sort(order);
      const set = new Set(pool);
      items.forEach((it) => { it.hidden = !set.has(it); });
      pool.forEach((it, i) => {
        list.appendChild(it); // sıraya göre yeniden diz
        it.hidden = i >= shown;
      });
      if (noneMsg) noneMsg.hidden = pool.length > 0;
      const left = Math.max(0, pool.length - shown);
      if (moreBtn) {
        moreBtn.hidden = left === 0;
        if (remaining) remaining.textContent = left ? ` (${left})` : '';
      }
      chips.forEach((c) => {
        const on = c.dataset.dabiReviewFilter === filter && !c.classList.contains('dabi-reviews__chip--reset');
        if (c.classList.contains('dabi-reviews__chip') && !c.classList.contains('dabi-reviews__chip--reset')) {
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', String(on));
        }
        if (c.classList.contains('dabi-reviews__bar')) c.classList.toggle('is-active', on);
      });
      if (resetChip) resetChip.hidden = filter === 'all';
      if (typeof window.DabiMotion?.refresh === 'function') window.DabiMotion.refresh(list);
    };

    chips.forEach((c) => {
      c.addEventListener('click', () => {
        const want = c.dataset.dabiReviewFilter;
        filter = filter === want && want !== 'all' ? 'all' : want;
        shown = perPage;
        render();
        if (c.classList.contains('dabi-reviews__bar') && list) {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    sortSel?.addEventListener('change', () => {
      sort = sortSel.value;
      shown = perPage;
      render();
    });

    moreBtn?.addEventListener('click', () => {
      shown += perPage;
      render();
    });

    /* ---------- uzun metin ---------- */
    const clampCheck = () => {
      root.querySelectorAll('[data-dabi-review-body]').forEach((body) => {
        const btn = body.parentElement.querySelector('[data-dabi-review-more]');
        if (!btn || body.classList.contains('is-open')) return;
        btn.hidden = body.scrollHeight <= body.clientHeight + 4;
      });
    };
    root.querySelectorAll('[data-dabi-review-more]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const body = btn.parentElement.querySelector('[data-dabi-review-body]');
        body.classList.add('is-open');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    /* ---------- ışık kutusu ---------- */
    const lb = root.querySelector('[data-dabi-review-lightbox]');
    const stage = lb?.querySelector('[data-dabi-review-lb-stage]');
    const caption = lb?.querySelector('[data-dabi-review-lb-caption]');
    let gallery = []; // { node: template, label }
    let at = 0;

    const showAt = (i) => {
      if (!stage || gallery.length === 0) return;
      at = (i + gallery.length) % gallery.length;
      stage.innerHTML = '';
      const tpl = gallery[at].tpl;
      stage.appendChild(tpl.content.cloneNode(true));
      const video = stage.querySelector('video');
      if (video) video.play().catch(() => {});
      if (caption) caption.textContent = `${gallery[at].label} · ${at + 1}/${gallery.length}`;
      lb.querySelectorAll('[data-dabi-review-lb-prev], [data-dabi-review-lb-next]').forEach((b) => { b.hidden = gallery.length < 2; });
    };

    const openFor = (id, index) => {
      if (!lb) return;
      const card = root.querySelector(`#yorum-${CSS.escape(id)}`);
      if (!card) return;
      const name = card.querySelector('.dabi-reviews__name')?.textContent.trim() || '';
      gallery = Array.from(card.querySelectorAll('[data-dabi-review-full]')).map((tpl) => ({ tpl, label: name }));
      if (gallery.length === 0) return;
      if (typeof lb.showModal === 'function') lb.showModal();
      else lb.setAttribute('open', '');
      document.documentElement.classList.add('dabi-scroll-locked');
      showAt(index);
    };

    const closeLb = () => {
      if (!lb) return;
      stage.querySelector('video')?.pause();
      if (lb.open && typeof lb.close === 'function') lb.close();
      else lb.removeAttribute('open');
      document.documentElement.classList.remove('dabi-scroll-locked');
      stage.innerHTML = '';
    };

    root.querySelectorAll('[data-dabi-review-open]').forEach((b) => {
      b.addEventListener('click', () => openFor(b.dataset.dabiReviewOpen, Number(b.dataset.mediaIndex) || 0));
    });
    lb?.querySelector('[data-dabi-review-lb-close]')?.addEventListener('click', closeLb);
    lb?.querySelector('[data-dabi-review-lb-prev]')?.addEventListener('click', () => showAt(at - 1));
    lb?.querySelector('[data-dabi-review-lb-next]')?.addEventListener('click', () => showAt(at + 1));
    lb?.addEventListener('close', () => document.documentElement.classList.remove('dabi-scroll-locked'));
    lb?.addEventListener('click', (e) => { if (e.target === lb) closeLb(); });
    lb?.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') showAt(at + 1);
      if (e.key === 'ArrowLeft') showAt(at - 1);
    });
    // Dokunmatik: yatay kaydırma ile geçiş.
    let touchX = null;
    lb?.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
    lb?.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) showAt(dx < 0 ? at + 1 : at - 1);
    }, { passive: true });

    /* ---------- form ---------- */
    const writeBtns = root.querySelectorAll('[data-dabi-review-write]');
    const formWrap = root.querySelector('[data-dabi-review-form-wrap]');
    // gönderim sonrası (başarı ya da hata mesajı) form görünür kalsın
    if (formWrap && formWrap.hidden && (/[?&]contact_posted=true/.test(window.location.search) || formWrap.querySelector('.dabi-reviews__ok, .dabi-reviews__err'))) {
      formWrap.hidden = false;
    }
    writeBtns.forEach((writeBtn) => writeBtn.addEventListener('click', () => {
      if (!formWrap) return;
      const open = formWrap.hidden;
      formWrap.hidden = !open;
      writeBtns.forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open) {
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        formWrap.querySelector('input[type="radio"]')?.focus({ preventScroll: true });
      }
    }));

    const rate = root.querySelector('[data-dabi-review-rate]');
    if (rate) {
      const out = rate.querySelector('[data-dabi-review-rate-out]');
      const radios = Array.from(rate.querySelectorAll('input[type="radio"]'));
      const paint = (n) => {
        radios.forEach((r, i) => r.nextElementSibling.classList.toggle('is-on', i < n));
      };
      radios.forEach((r, i) => {
        r.addEventListener('change', () => { paint(i + 1); if (out) out.textContent = `${i + 1} / 5`; });
        r.nextElementSibling.addEventListener('pointerenter', () => paint(i + 1));
      });
      rate.addEventListener('pointerleave', () => {
        const on = radios.findIndex((r) => r.checked);
        paint(on + 1);
      });
    }

    // Form başarıyla gönderildiyse sayfa #yorumlar ile döner; mesaja odaklan.
    const ok = root.querySelector('[data-dabi-review-ok]');
    if (ok) {
      if (formWrap) formWrap.hidden = false;
      ok.scrollIntoView({ block: 'center' });
      ok.focus({ preventScroll: true });
    }

    render();
    clampCheck();
    window.addEventListener('resize', clampCheck, { passive: true });

    // Ürün başlığı altındaki özet bağlantısı: yumuşak kaydır.
    document.querySelectorAll('[data-dabi-review-jump]').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  document.querySelectorAll('[data-dabi-reviews]').forEach(setup);
  document.addEventListener('shopify:section:load', (e) => setup(e.target.querySelector('[data-dabi-reviews]')));
})();
